module.exports = __webpack_public_path__ + "static/rws-webhook-events-66ee9f79d862e6eca4a69390147bd446.jpeg";